module.exports = __webpack_public_path__ + "static/media/decoration_light.5a5ed864.svg";